import { ErrorWithParamBase } from '@/errors/ErrorWithParamBase';
import { AuthParams } from '@/models/domain/AuthParams';

export class AutoLoginError extends ErrorWithParamBase<AuthParams> {
    static get defaultMessage(): string {
        return '自動ログインに失敗しました。';
    }

    static get errorName(): string {
        return 'AutoLoginError';
    }
}
